import { Component, EventEmitter, Input, Output, } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, EnvironmentConfig, IAdmin, IUser } from '@clooper/core';
import { faBars, faBell, faChevronDown, faSignOut, faTimes } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  @Input() label: string = 'Already have an account?'
  @Input() actionText: string = 'Login instead';
  @Input() actionURL: string;
  @Input() isExternalURL: string;
  @Input() showActions: boolean = true
  @Input() signOutBeforeAction: boolean = false;


  websiteURL: string | undefined;

  constructor(
    config: EnvironmentConfig,
    private router: Router,
    private authService: AuthService
  ) {
    this.websiteURL = config.websiteUrl
  }

  onActionClick(): void {
    if (this.signOutBeforeAction) {
      this.authService.signout();
    }

    if (this.actionURL) {
      this.router.navigate([this.actionURL]);
    }
  }


}
